import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import CardPattern from '@mlb/react-patterns/components/Card';
import { Elevation } from '@mlb/react-patterns/components/Card/card.types';

const Card = styled(CardPattern)`
    display: block;
    position: relative;
    padding-top: ${({ $width, $height }) => $height * 100 / $width}%;
    width: 100%;
    text-decoration: none; // If rendered as an anchor tag, remove underline
    overflow: hidden;
`;

export const Container = styled.div`
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
`;

const AspectRatioCard = (props) => {

    const {
        aspectRatio,
        children,
        as,
        ...otherProps
    } = props;

    const [
        width,
        height,
    ] = aspectRatio.split(':');

    return (
        <Card
            elevation={Elevation.NONE}
            $width={width}
            $height={height}
            forwardedAs={as}
            {...otherProps}
        >
            <Container>
                {children}
            </Container>
        </Card>
    );

};

AspectRatioCard.propTypes = {
    aspectRatio: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
};

export default AspectRatioCard;
